import React from 'react';
import { Stack } from 'expo-router';

import { useModalStackOptions } from '../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function ModalsLayout() {
  const options = useModalStackOptions();

  return (
    <Stack screenOptions={options.Stack}>
      <Stack.Screen name="add-gift-card/index" options={options.AddGiftCard} />
      <Stack.Screen
        name="add-gift-card/[giftCardId]/index"
        options={options.AddGiftCard}
      />
      <Stack.Screen name="bag/index" options={options.Bag} />
      <Stack.Screen
        name="ca-data-requests/index"
        options={options.WithHeader}
      />
      <Stack.Screen name="chat/index" options={options.Chat} />
      <Stack.Screen name="credit/add/index" options={options.WithHeader} />
      <Stack.Screen name="credit/index" options={options.WithHeader} />
      <Stack.Screen
        name="delivery-order-in-flight/index"
        options={options.DeliveryOrderInFlight}
      />
      <Stack.Screen
        name="dietary-restrictions/index"
        options={options.WithHeader}
      />
      <Stack.Screen
        name="feedback/[orderId]/index"
        options={options.Feedback}
      />
      <Stack.Screen
        name="forgot-to-scan/index"
        options={options.ForgotToScan}
      />
      <Stack.Screen
        name="order-product/[productSlug]/confirm-location/index"
        options={options.OrderProduct}
      />
      <Stack.Screen
        name="order-product/[productSlug]/index"
        options={options.OrderProduct}
      />
      <Stack.Screen
        name="order-product/[productSlug]/search-location/index"
        options={options.OrderProduct}
      />
      <Stack.Screen
        name="order-status/[orderId]/index"
        options={options.OrderStatus}
      />
      <Stack.Screen
        name="personal-data-details/index"
        options={options.PersonalData}
      />
      <Stack.Screen
        name="redeem-gift-card/index"
        options={options.RedeemGiftCard}
      />
      <Stack.Screen
        name="redeem-gift-card/[giftCardId]/index"
        options={options.RedeemGiftCard}
      />
      <Stack.Screen name="reorder/index" options={options.Reorder} />
      <Stack.Screen
        name="reorder-active-bag-warning/index"
        options={options.ReorderSubScreen}
      />
      <Stack.Screen
        name="reorder-change-location/index"
        options={options.ReorderSubScreen}
      />
      <Stack.Screen
        name="reorder-confirm-location/index"
        options={options.ReorderSubScreen}
      />
      <Stack.Screen
        name="reorder-conflict-review/index"
        options={options.ReorderSubScreen}
      />
      <Stack.Screen
        name="share/[lineItemSlug]/index"
        options={options.WithHeader}
      />
      <Stack.Screen name="upsell/index" options={options.Upsell} />
      <Stack.Screen name="payments/index" options={options.Payments} />
    </Stack>
  );
}
